<template>
  <v-list-item-group>
    <v-list-item
      class="px-2 py-0"
      v-for="note in relatedNotes"
      :key="note.guid"
      @click="onOpenInNew(note)"
    >
      <v-list-item-content class="py-2">
        <v-row no-gutters justify="center">
          <v-col class="pr-1">
            <v-icon small class="mr-2">mdi-open-in-new</v-icon>
            <span class="primary--text">{{
              utility.truncateString(note.title, 30)
            }}</span>
            <template v-if="noteViews[note.guid]">
              <v-chip
                label
                x-small
                class="mt-n1 ml-1 px-1"
                :color="noteViews[note.guid] > 10 ? 'red' : 'primary'"
                outlined
                >{{ noteViews[note.guid] }}</v-chip
              >
            </template>
            <template v-else>
              <v-icon small color="blue">mdi-circle-medium</v-icon>
            </template>
            <span class="ml-2 caption primary--text">
              {{ dateService.getFormattedShort(note.created) }}
            </span>
          </v-col>
          <!-- <v-col cols="1" align="right">
        <v-btn icon color="primary" @click.stop="onOpenInNew(note)">
        <v-icon small class="mr-2">mdi-open-in-new</v-icon>
        </v-btn>
    </v-col>-->
        </v-row>
      </v-list-item-content>
    </v-list-item>
  </v-list-item-group>
</template>

<script>
import dateService from '@/services/DateService'
import utility from '@/services/UtilityService'

export default {
  props: {
    relatedNotes: {
      type: Array
    },
    noteViews: {
      type: Object
    }
  },
  computed: {
    dateService: () => dateService,
    utility: () => utility
  },
  data() {
    return {}
  },
  methods: {
    onOpenInNew(note) {
      this.$emit('clickInNew', note)
    }
  }
}
</script>

<style scoped></style>
